// extracted by mini-css-extract-plugin
export default {"root":"WK6cJRTJ","label":"_3MzTnH7r","arrow":"_2jCv7cQc"};